// @ts-nocheck
import React, { useMemo, useCallback, useEffect } from "react";
import _ from "lodash";

import { reduxForm, change, touch, type InjectedFormProps } from "redux-form/dist/redux-form";
import { compose } from "@reduxjs/toolkit";

import { COLORS, FLEX, SPACES, STYLES } from "styles-js";
import { InputField, CheckboxField } from "kit/form";
import FormProvider, { type FormActionType } from "core/FormProvider";
import otpListener from "core/OtpListener";
import { Button, CountDownTimer, ProgressBar } from "kit/ui";
import { Container } from "kit/grid";
import { Validation } from "kit/helpers";
import Checkbox from "kit/form/Checkbox";

import COUNTRY from "../../../constants/COUNTRY";

import routesObject from "../../../routesObject";

import * as styles from "./Handover.OtpValidate.styles.js";


// const validate = (values, props) => ({ newPassword2: Validation.sameAs(values.newPassword)(values.newPassword2) });
// const asyncValidate = (values) => Promise.reject({ emailAddress: "Invalid e-mail" });

const FORM_NAME = "handoverOtpValidateForm";

type ComponentPropTypes = {
  affiliateDetails?: object;
  canRequestNewPin?: boolean;
  requestNewPin?: () => void;
  otpSendingInProgress?: boolean;
  handleOpenChangePhoneNumberModal?: () => void;
  toggleRequestingNewPinToTrue?: () => void;
};

function OtpValidateForm(props: InjectedFormProps & ComponentPropTypes) {
  const { dispatch } = props;

  const validators = useMemo(() => ({
    required: Validation.required(),
    pin: Validation.pattern(COUNTRY.patterns.otp)
  }), []);

  const handleToggleSelectAll = useCallback((e) => {
    dispatch(touch(OtpValidateForm.NAME, "acceptAgreement"));
    dispatch(touch(OtpValidateForm.NAME, "acceptPolicy"));
    dispatch(change(OtpValidateForm.NAME, "acceptAgreement", e.target.checked));
    dispatch(change(OtpValidateForm.NAME, "acceptPolicy", e.target.checked));
  }, [ dispatch ]);

  const scrollToPin = useCallback(() => {
    const element = document.getElementById("phone-number");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  }, []);

  const autofillOtpValue = useCallback(async() => {
    const code = await otpListener.startHandling();
    dispatch(change(OtpValidateForm.NAME, "pin", code));
  }, [ dispatch ]);

  useEffect(() => {
    autofillOtpValue();
  }, [ autofillOtpValue ]);

  useEffect(() => {
    return () => {
      otpListener.stop();
    };
  }, []);

  const {
    handleSubmit,
    // initialValues,
    // pristine,
    // invalid,
    // valid,
    submitting,
    // anyTouched,
    // dirty,
    // pure,
    // submitFailed,
    // submitSucceeded,
    // error,
    asyncValidating,
    // initialized,
    fields: {
      pin,
      acceptPolicy,
      acceptAgreement
    },
    // dispatch,
    // formErrors,
    // formValues,
    // formMeta,
    // handleReset,
    // handleClear,
    // formSubmit,
    formAction,
    affiliateDetails,
    canRequestNewPin,
    requestNewPin,
    otpSendingInProgress,
    handleOpenChangePhoneNumberModal,
    toggleRequestingNewPinToTrue,
    formValues
  } = props;

  return (
    <form
      name={FORM_NAME}
      id={FORM_NAME}
      onSubmit={handleSubmit(formAction)}
      noValidate>
      <div
        css={[
          _.isEmpty(affiliateDetails) && STYLES.loading
        ]}>
        <Container>
          <InputField
            id="pin"
            name="pin"
            label="N&uacute;mero de PIN"
            inputMode="numeric"
            autoComplete="one-time-code"
            required
            minLength={4}
            maxLength={6}
            onFocus={scrollToPin}
            validate={[
              validators.required,
              validators.pin
            ]} />

          <div css={[
            canRequestNewPin && SPACES.marBot10,
            FLEX.displayFlex,
            FLEX.directionColumn,
            FLEX.alignItemsCenter,
            FLEX.justifyContentCenter
          ]}>
            <Button
              onClick={handleOpenChangePhoneNumberModal}
              unstyled
              style={{
                fontSize: 14,
                ":hover": {
                  color: COLORS.primary
                }
              }}
              content="Quiero cambiar mi n&uacute;mero de m&oacute;vil" />

            {!canRequestNewPin && (
              <div css={SPACES.mar10}>
                <ProgressBar duration="60" />
                <div style={{ fontSize: 12 }}>
                  Puedes solicitar un nuevo PIN en
                  {" "}
                  <span css={{
                    marginTop: 5,
                    width: "40px",
                    display: "inline-block"
                  }}>
                    <CountDownTimer
                      duration={60}
                      onComplete={toggleRequestingNewPinToTrue} />
                  </span>
                </div>
              </div>
            )}

            {canRequestNewPin && (
              <Button
                css={SPACES.mar10}
                onClick={() => requestNewPin()}
                loading={otpSendingInProgress}
                disabled={otpSendingInProgress}
                unstyled
                style={{
                  fontSize: 14,
                  color: COLORS.primary,
                  ":hover": {
                    color: COLORS.primary
                  }
                }}
                content="No he recibido el PIN" />
            )}

          </div>
          {/* <div css={{ marginTop: 10 }}>
                <Button
                  id="btn-handoverRequestNewPin"
                  size="small"
                  onClick={requestNewPin}
                  loading={otpSendingInProgress}
                  disabled={otpSendingInProgress}
                  outline
                  theme="primary"
                  content="No he recibido el PIN" />
              </div> */}
          <Checkbox
            disabled={submitting}
            checked={!!formValues.acceptAgreement && !!formValues.acceptPolicy}
            onChange={handleToggleSelectAll}>
            <span id="accepta-todo" css={styles.acceptAllCheckbox}>
              ACEPTAR TODO
            </span>
          </Checkbox>

          <CheckboxField name="acceptAgreement">
            <span css={{ fontSize: "12px" }}>
              Acepto recibir comunicaciones de marketing sobre productos y ofertas de myKredit o Trive Credit Spain, S.L.
            </span>
          </CheckboxField>

          <CheckboxField
            name="acceptPolicy"
            validate={[
              validators.required
            ]}
            fieldProps={{
              style: {
                marginBottom: 12
              }
            }}>
            <span css={{ fontSize: "12px" }}>
              He leído y acepto la <a style={{ display: "inline" }} target="_blank" href={routesObject.privacyPolicy.url}>Política de Privacidad</a>.
            </span>
          </CheckboxField>

          {/*             <div css={styles.infoField}>
            <span>
              <br /> Responsable: Trive Credit Spain, S.L., o myKredit
              <br /> Finalidad: Concesión de micropréstamos
              <br /> Derechos: Acceso, rectificatión, modificación, cancelación, supresión, oposición al tratamiento, revocación, limitación o el ejercicio a la portabilidad de los datos. <br />
              <br /> Para más información, puede consultar la <a target="_blank" href={routesObject.privacyPolicy.url}>Política de Privacidad</a>.
            </span>
          </div> */}

          <div>
            <Button
              id={`btn-${FORM_NAME}`}
              form={FORM_NAME}
              css={styles.submitButton}
              type="submit"
              theme="orange"
              fluid
              disabled={submitting || asyncValidating}
              loading={submitting || asyncValidating}
              content="Enviar" />
          </div>
        </Container>
      </div>

    </form>
  );
}

OtpValidateForm.NAME = FORM_NAME;
OtpValidateForm.ACTIONS = undefined as FormActionType;
OtpValidateForm.PREFIX = "##form/HANDOVER/OTP_VALIDATE";

export default compose(
  FormProvider,
  reduxForm({
    form: FORM_NAME,
    enableReinitialize: false,
    // validate,
    // asyncValidate,
    fields: [
      "pin",
      "acceptPolicy",
      "acceptAgreement"
    ]
  })
)(OtpValidateForm);
